export const validateForm = (values = {}, requiredFields = []) => {
  let validRequiredFields = 0

  requiredFields.forEach((fieldName) => {
    if (values[fieldName]) {
      validRequiredFields++
    }
  })

  return validRequiredFields === requiredFields.length
}

export const validateEmail = (mail) => {
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
    return true
  }
  return false
}

export const validatePhoneNumber = (number) => {
  if (
    /^(\+\d{1,3}( )?)((\(\d{3}\))|\d{3})[- .]?\d{3}[- .]?\d{4}$/im.test(number)
  ) {
    // Expresion regular SIN codigo Pais --- /^[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,7}$/im.test(number) ---
    return true
  }
  return false
}

export const validateContent = (validate, value) => {
  if (validate) {
    return !!value
  } else {
    return true
  }
}
